export const data = {
    "breakfast": {
		"en": "Breakfast",
		"fr": "Déjeuner"
    },
    "burgers": {
		"en": "Burgers",
		"fr": "Burgers"
	  },
    "chicken": {
		"en": "Chicken & More",
		"fr": "Poulet et autres"
    },
    "chicken_header": {
      "en": "Chicken",
      "fr": "Poulet"
    },
    "chubby chicken": {
		"en": "Chubby Chicken",
		"fr": "Poulet Chubby"
	  },
    "chicken & more": {
		"en": "Chicken & More",
		"fr": "Poulet et autres"
    },
    "drinks": {
        "en": "Drinks",
        "fr": "Boissons"
    },
    "sides": {
        "en": "Sides",
        "fr": "À-côtés"
    },
    "brewbar": {
      "en": "Brew Bar",
      "fr": "Le Brew Bar"
    },
    "kidspack": {
      "en": "Kids' Pack",
      "fr": "Régal pour enfants"
    },
    "featured": {
      "en": "Featured",
      "fr": "En vedette"
    },
    "pret": {
      "en": "Pret",
      "fr": "Pret"
    }

}